import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './authConfig';

async function renderApp() {
  await msalInstance.initialize();
  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
  root.render(
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    );
  }

renderApp();
